import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import { FormProvider, useForm } from 'react-hook-form';
import _ from 'lodash';
import {
  FormFieldDefinition,
  IExternalFieldDependency
} from '@publishing-engine/domain/types/article';
import { generateValidationSchema } from '../../../../utils/validation';
import { ajvResolver } from '@hookform/resolvers/ajv';
import { FormFieldSelect as IFormFieldSelect } from '@publishing-engine/domain/types/article';
import CustomFormFieldComponent from 'src/components/FormField/CustomFormFieldComponent';

interface IProps {
  isOpen: boolean;
  onSubmit: (value: string) => void;
  onCancel: () => void;
  formField: IFormFieldSelect;
  value: string;
  externalDependency?: IExternalFieldDependency;
}

export type ISelectFormState = {
  preference?: {
    [key in 'subjectArea']: string;
  };
};

const SelectUpdateModal: React.FC<IProps> = props => {
  const { isOpen, onSubmit, onCancel, formField, externalDependency } = props;

  const defaultValues = _.merge(
    {} as ISelectFormState,
    _.set({}, formField.caseDataFields.main, props.value),
    externalDependency
      ? _.set({}, externalDependency.path, externalDependency?.value)
      : {}
  );

  const schema = generateValidationSchema({
    [formField.name]: formField
  } as Record<string, FormFieldDefinition>);

  const methods = useForm({
    defaultValues,
    resolver: ajvResolver(schema)
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        gap={8}
        bgColor="surfacePrimaryFill"
        flexDirection="column"
        borderRadius="base"
      >
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(data => {
              onSubmit(_.get(data, formField.caseDataFields.main));
            })}
          >
            <Flex
              padding={8}
              gap={6}
              bgColor="surfacePrimaryFill"
              flexDirection="column"
              borderRadius="base"
            >
              <Flex maxHeight={700} overflow={'auto'}>
                <CustomFormFieldComponent config={formField} />
              </Flex>
              <Flex
                gap={2}
                justifyContent="flex-end"
                alignItems="center"
                alignSelf="stretch"
              >
                <Button
                  variant="secondary"
                  onClick={onCancel}
                  borderRadius="small"
                >
                  Exit Without Saving
                </Button>
                <Button variant="primary" type="submit" borderRadius="small">
                  Save Changes
                </Button>
              </Flex>
            </Flex>
          </form>
        </FormProvider>
      </Flex>
    </Modal>
  );
};

export default SelectUpdateModal;
